







import { Component, Vue, Prop } from 'vue-property-decorator';
import ProjectsList from '@/components/ProjectsList.vue';
import NotLoggedPanel from '@/components/NotLoggedPanel.vue';
import { User } from '@/models/user';

@Component({
    name: 'Portfolio',
    components: {
        ProjectsList,
        NotLoggedPanel
    }
})
export default class Portfolio extends Vue {
    @Prop() private user!: User;
}
